import React, { useRef } from 'react';
import css from './LandingPage.module.css';
import { injectIntl, intlShape, FormattedMessage } from '../../util/reactIntl';
import {
  HeroImageBackground,
  RecombeeRecommendations,
  SectionDestinations,
  NamedLink
} from '../../components';

import SectionKeyPoints from './sections/SectionKeyPoints/SectionKeyPoints';
import SectionLocationCategory from './sections/SectionLocations/SectionLocationCategory';
import SectionHowItWorks from './sections/SectionHowItWorks/SectionHowItWorks';
import SectionSAProgramSummary from './sections/SectionSAProgramSummary/SectionSAProgramSummary';
import SectionSATiers from './sections/SectionSATiers/SectionSATiers';
import SectionSAChart from './sections/SectionSAChart/SectionSAChart';
import SectionBnbsProgramSummary from './sections/SectionBnbsProgramSummary/SectionBnbsProgramSummary';
import SectionBnbsWorkingWith from './sections/SectionBnbsWorkingWith/SectionBnbsWorkingWith';
import SectionBnbsBook from './sections/SectionBnbsBook/SectionBnbsBook';
import SectionBnbsBookMobile from './sections/SectionBnbsBook/SectionBnbsBookMobile';
import SectionBnbsFeaturedIn from './sections/SectionBnbsFeaturedIn/SectionBnbsFeaturedIn';
import SectionBnbsHelp from './sections/SectionBnbsHelp/SectionBnbsHelp';
import SectionHero from './sections/SectionHero/SectionHero';

const LandingpageContent = (props) => {
 
  const {
    history,
    intl,
    location,
    scrollingDisabled,
    currentUserListing,
    currentUserListingFetched,
    showRecomms,
    pageContent,
  } = props;

  const {
    showSectionKeyPoints,
    showSectionDestinations,
    showRecombeeRecommendations,
    showSectionLocationCategory,
    showSectionHowItWorks,
    showBnbButton,
    showSectionSAProgramSummary,
    showSectionSAChart,
    showSectionSATiers,
    showSectionBnbsProgramSummary,
    showSectionBnbsWorkingWith,
    showSectionBnbsBook,
    showSectionBnbsBookMobile,
    showSectionBnbsFeaturedIn,
    showSectionBnbsHelp
  } = pageContent;

  const sectionRef = useRef(null);

  // handleOnClick - responsible for handling the smooth scroll to the section
  // defined by the sectionRef variable
  const handleOnClick = (e) => {
    e.preventDefault();

    sectionRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  };

  return (
    <>
      {/* For Home Page, show our new Hero Image and skip normal flow*/}
      {location.pathname !== "/home" ? (
        <div className={css.heroContainer}>
        <SectionHero className={css.hero} history={history} location={location} handleOnClick={handleOnClick} />
      </div>
      ):
      (
      <HeroImageBackground
        title = { {id:"SectionHero.title", values: {}}}
        highlight={"lifetime|Memories|memoráveis"}
        description={{id:"SectionHero.subTitle", values:{}}} 
        ctaText={{id:"SectionHero.browseButton", values:{}}}
        alt="Drone view of Madeira Island" 
        />
      )
      }

    <ul className={css.sections}>
    {/* home landing page */}
      {showSectionKeyPoints && (
        <li className={css.section}>
          <div className={css.sectionKeyPoints}>
            <SectionKeyPoints />
          </div>
        </li>
      )}
      {showSectionDestinations && (
      <li className={css.section}>
        <div className={css.sectionDestinationsContent}>
          <SectionDestinations landingPage={true} />
        </div>
      </li>
      )}
      {showRecombeeRecommendations && (
        <li className={css.section}>
          <div className={css.recombeeSectionContent}>
            <RecombeeRecommendations
              intl={intl}
              history={history}
              showRecomms={showRecomms}
              largeTitle={true}
              useEmbla={true}
            />
          </div>
        </li>
      )}
      {showSectionLocationCategory && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionLocationCategory titleId="SectionLocationCategory.title" location={location}/>
          </div>
        </li>
      )}
{/* SA landing page */}
      {showBnbButton && (
        <li className={css.section}>
          <div className={css.bnbsALButtonWrapper}>
            <NamedLink name="Bnbs" className={css.bnbsALButton}>
              <FormattedMessage id="LandingPageSA.ALButtonText" />
            </NamedLink>
          </div>
        </li>
      )}
      {showSectionSAProgramSummary && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionSAProgramSummary
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {showSectionHowItWorks && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionHowItWorks
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
              location={location}
              ref={sectionRef}
            />
          </div>
        </li>
      )}
      {showSectionSAChart && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionSAChart
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {showSectionSATiers && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionSATiers
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
{/* Bnbs landing page */}
      {showSectionBnbsProgramSummary && (
        <li className={css.altSection}>
          <div className={css.sectionContentFirstChild}>
            <SectionBnbsProgramSummary
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {showSectionBnbsWorkingWith && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionBnbsWorkingWith
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {showSectionBnbsBook && (
        <li className={css.altSection}>
          <div className={css.sectionBnbBook}>
            <SectionBnbsBook
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {/* section book for mobile screens */}
      {showSectionBnbsBookMobile && (
        <li className={css.altSection}>
          <div className={css.sectionBnbBookMobile}>
            <SectionBnbsBookMobile
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {/* end of section book for mobile */}
      {showSectionBnbsFeaturedIn && (
        <li className={css.altSection}>
          <div className={css.sectionContent}>
            <SectionBnbsFeaturedIn
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
            />
          </div>
        </li>
      )}
      {showSectionBnbsHelp && (
        <li className={css.section}>
          <div className={css.sectionContent}>
            <SectionBnbsHelp
              currentUserListing={currentUserListing}
              currentUserListingFetched={currentUserListingFetched}
              intl={intl}
            />
          </div>
        </li>
      )}
    </ul>
    </>
  );
};

export default LandingpageContent;